import { useState } from "react";
import { Link } from "react-router-dom";
import { cx } from "class-variance-authority";
import {
  LayoutDashboard,
  Briefcase,
  FileText,
  ArrowLeftRight,
  ClipboardList,
} from "lucide-react";
import SidebarChevron from "@/assets/icons/SidebarChevron";

export default function SidebarServiceEngineer({ sidebarMinMax = false }) {
  const [jf, setJf] = useState(false);

  // Helper function to handle accordion behavior - close all other groups when one is opened
  const handleGroupToggle = (groupSetter, currentValue) => {
    // Close all groups
    setJf(false);
    // Toggle the target group
    groupSetter(!currentValue);
  };

  return (
    <>
      {/* Dashboard */}
      <Link
        to={"/service-engineer/dashboard"}
        className={cx(
          "flex",
          "items-center",
          "gap-3",
          "px-4",
          "py-3",
          "rounded-lg",
          "text-gray-700",
          "hover:bg-blue-50",
          "hover:text-blue-700",
          "transition-all",
          "duration-200",
          "group",
          "whitespace-nowrap",
          sidebarMinMax && "justify-center",
        )}
      >
        <LayoutDashboard className="w-5 h-5 text-gray-400 group-hover:text-blue-600" />
        {!sidebarMinMax && (
          <span className="font-medium whitespace-nowrap">Dashboard</span>
        )}
      </Link>

      {/* Job Fulfillment */}
      <div className="space-y-1">
        <button
          className={cx(
            "w-full",
            "flex",
            "items-center",
            "justify-between",
            "px-4",
            "py-3",
            "rounded-lg",
            "text-gray-700",
            "hover:bg-gray-100",
            "transition-all",
            "duration-200",
            "group",
          )}
          onClick={() => {
            handleGroupToggle(setJf, jf);
          }}
        >
          <div className="flex items-center gap-3">
            <Briefcase className="w-5 h-5 text-gray-400 group-hover:text-gray-600" />
            {!sidebarMinMax && (
              <span className="font-medium whitespace-nowrap">
                Job Fulfillment
              </span>
            )}
          </div>
          {!sidebarMinMax && (
            <SidebarChevron
              className={`transition-transform duration-200 ${
                jf ? "rotate-180" : ""
              }`}
            />
          )}
        </button>
        {jf && !sidebarMinMax && (
          <div className="ml-6 space-y-1 border-l-2 border-gray-100 pl-4">
            <Link
              to={"/service-engineer/jf/maintenance/CORRECTIVE_MAINTENANCE"}
              className={cx(
                "block",
                "px-3",
                "py-2",
                "text-sm",
                "text-gray-600",
                "hover:text-blue-600",
                "hover:bg-blue-50",
                "rounded-md",
                "transition-all",
                "duration-200",
                "whitespace-nowrap",
              )}
            >
              Corrective Maintenance
            </Link>
            <Link
              to={
                "/service-engineer/jf/maintenance/PREVENTIVE_MAINTENANCE"
              }
              className={cx(
                "block",
                "px-3",
                "py-2",
                "text-sm",
                "text-gray-600",
                "hover:text-blue-600",
                "hover:bg-blue-50",
                "rounded-md",
                "transition-all",
                "duration-200",
                "whitespace-nowrap",
              )}
            >
              Preventive Maintenance
            </Link>
            <Link
              to={"/service-engineer/jf/maintenance/OTHER_MAINTENANCE"}
              className={cx(
                "block",
                "px-3",
                "py-2",
                "text-sm",
                "text-gray-600",
                "hover:text-blue-600",
                "hover:bg-blue-50",
                "rounded-md",
                "transition-all",
                "duration-200",
                "whitespace-nowrap",
              )}
            >
              Other Maintenance
            </Link>
          </div>
        )}
      </div>

      {/* Other Links */}
      <Link
        to={"/service-engineer/sot/leave"}
        className={cx(
          "flex",
          "items-center",
          "gap-3",
          "px-4",
          "py-3",
          "rounded-lg",
          "text-gray-700",
          "hover:bg-blue-50",
          "hover:text-blue-700",
          "transition-all",
          "duration-200",
          "group",
          "whitespace-nowrap",
          sidebarMinMax && "justify-center",
        )}
      >
        <FileText className="w-5 h-5 text-gray-400 group-hover:text-blue-600" />
        {!sidebarMinMax && (
          <span className="font-medium whitespace-nowrap">
            Job Report Delivery
          </span>
        )}
      </Link>

      <Link
        to={"/service-engineer/sot/part-return"}
        className={cx(
          "flex",
          "items-center",
          "gap-3",
          "px-4",
          "py-3",
          "rounded-lg",
          "text-gray-700",
          "hover:bg-blue-50",
          "hover:text-blue-700",
          "transition-all",
          "duration-200",
          "group",
          "whitespace-nowrap",
          sidebarMinMax && "justify-center",
        )}
      >
        <ArrowLeftRight className="w-5 h-5 text-gray-400 group-hover:text-blue-600" />
        {!sidebarMinMax && (
          <span className="font-medium whitespace-nowrap">
            Part Return
          </span>
        )}
      </Link>

      <Link
        to={"/service-engineer/sot/part-request"}
        className={cx(
          "flex",
          "items-center",
          "gap-3",
          "px-4",
          "py-3",
          "rounded-lg",
          "text-gray-700",
          "hover:bg-blue-50",
          "hover:text-blue-700",
          "transition-all",
          "duration-200",
          "group",
          "whitespace-nowrap",
          sidebarMinMax && "justify-center",
        )}
      >
        <ClipboardList className="w-5 h-5 text-gray-400 group-hover:text-blue-600" />
        {!sidebarMinMax && (
          <span className="font-medium whitespace-nowrap">
            Part Request List
          </span>
        )}
      </Link>
    </>
  );
}
